import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgDiscovery({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 6.5a.5.5 0 01.5-.5h19a.5.5 0 01.5.5v11a.5.5 0 01-.5.5h-19a.5.5 0 01-.5-.5v-11z"
        fill="#F5F5F5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.823 18C16.64 16.374 22 12.74 22 12.74v4.76a.5.5 0 01-.5.5H6.822z"
        fill="#E6772F"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.658 11.964a.779.779 0 000-1.16c-.158-.135-.341-.187-.647-.187h-.127v1.532h.127c.306 0 .497-.056.647-.185zm-.552-1.74c.765 0 1.299.475 1.299 1.16 0 .341-.164.67-.44.89-.232.184-.497.267-.864.267h-.69v-2.317h.695zm1.517 0h.47v2.317h-.47v-2.317zm1.626.888c.537.188.697.355.697.724 0 .447-.345.761-.835.761-.36 0-.62-.136-.838-.441l.304-.282a.56.56 0 00.515.31c.211 0 .367-.14.367-.328a.273.273 0 00-.141-.239 1.815 1.815 0 00-.327-.132c-.443-.154-.595-.317-.595-.637 0-.377.327-.662.755-.662.265 0 .508.086.71.257l-.245.309c-.124-.133-.24-.187-.382-.187-.204 0-.352.11-.352.256 0 .125.083.192.367.291zm.846.271c0-.673.572-1.211 1.288-1.211.204 0 .374.041.581.141v.532c-.196-.184-.367-.26-.59-.26a.786.786 0 00-.792.795c0 .47.336.799.812.799.215 0 .38-.072.57-.254v.533a1.35 1.35 0 01-.59.135c-.72 0-1.28-.528-1.28-1.21zm5.695.397l.655-1.556h.51L14.91 12.6h-.253l-1.027-2.376h.515l.646 1.556zm1.38.761v-2.317h1.339v.393h-.867v.514h.834v.392h-.834v.626h.867v.392h-1.34zm2.26-1.251c.304 0 .462-.125.462-.357 0-.226-.158-.344-.453-.344h-.145v.7h.137zm.948-.382c0 .354-.195.587-.551.657l.761.976h-.58l-.653-.931h-.061v.931h-.474v-2.317h.702c.545 0 .856.25.856.684z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.696 11.39c0 .666-.565 1.207-1.262 1.207-.698 0-1.263-.54-1.263-1.208 0-.667.565-1.208 1.263-1.208.697 0 1.262.54 1.262 1.208z"
        fill="#E6772F"
      />
    </svg>
  )
}

export default SvgDiscovery
